export const HTTP_REQUEST_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  Q: 'q',
};

export const SEARCH_PARAM_KEYS = {
  EPIC_DEPARTMENT_ID: 'epicDepartmentId',
  HAS_REFERRAL: 'hasReferral',
  MNEMONIC: 'mnemonic',
  NEXT_URL: 'nextUrl',
  NPI: 'npi',
  WORKFLOW: 'workflow',
};

export const SESSION_STORAGE_KEYS = {
  ACCESSIBILITY_TYPE: 'slotAccessibilityType',
  APPOINTMENT_LOCATION: 'appointmentLocation',
  APPOINTMENT_NOTES_REQUIRED: 'appointmentNotesRequired',
  APPOINTMENT_TYPE: 'appointmentType',
  DURATION_MINS: 'durationMins',
  EMAIL: 'email',
  EPIC_APPOINTMENT_TYPE: 'epicAppointmentType',
  EPIC_DEPARTMENT_ID: 'epicDepartmentId',
  EPIC_PROVIDER_ID: 'epicProviderId',
  HAS_REFERRAL: 'hasReferral',
  INSURANCE_REQUIREMENT: 'insuranceRequirement',
  MNEMONIC: 'mnemonic',
  RECENT_CONDITION: 'recent-condition',
  REFERRAL_REQUIREMENT: 'referralRequirement',
  RESERVATION_KEY: 'reservationKey',
  RESERVED_TIME_SLOT: 'reservedTimeSlot',
  RESULT_TYPE: 'resultType',
  UNAVAILABLE_SLOT: 'unavailableSlot', // Format: epicProviderId|epicDepartmentId|slotTime
  VIRTUAL_URGENT_CARE_SESSION_ID: 'virtualUrgentCareSessionId',
};

export const TIME_ZONES = {
  LOCAL: 'local',
  AMERICA_NEW_YORK: 'America/New_York',
};

export const WORKFLOWS = {
  MYCHART: 'mychart',
};
